declare global {
  interface Window {
    // Set by the handoff destination page when a LINE flow has just completed
    // for a guest; read and removed once by stores/line.ts. Optional because
    // it is absent on every other page load, and deletable because the store
    // removes it after adopting the token.
    lineLinkToken?: string;
  }
}

// The request header stores/line.ts sends the token back on. Must match
// Line::LINK_HEADER (app/models/line.rb), which GraphqlController reads.
export const LINE_LINK_HEADER = "X-Line-Link-Token";
